<template>
  <div style="position: relative;" :style="mainStyle">
    <div class="taxiAc-page" :style="mainStyle">
      <img v-if="lang == 'zh'" src="../../images/banner_2_zh.png" class="w-f">
      <img v-else-if="lang == 'km'" src="../../images/banner_2_km.png" class="w-f">
      <img v-else src="../../images/banner_2_en.png" class="w-f">
      <span class="flex-xy-center taxiAc-page-title">{{ $root.getText('sorry') }}</span>

      <RuleDialog :data="ruleData"></RuleDialog>

      <div class="taxiAc-page-subtitle">
        <div>{{ $root.getText('redeemCoupon') }}</div>
        <div v-if="msg" class="mt-6">{{ msg }}</div>
      </div>

      <div class="taxiAc-page-srl">
        <div class="taxiAc-srl-title">{{ $root.getText('abaPayGetSpin') }}</div>

        <div class="taxiAc-srl-coupon flex-xy-center">
          <img src="../../images/wc.png" class="taxiAc-srl-icon">
          <span class="font-14">{{ $root.getText('spinningWheel') }}</span>
        </div>

        <div @click="goPassPage" class="taxiAc-srl-btn">{{ $root.getText('bookNow') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivity, receiveCoupon } from "../../../apis/api";
import { urlQueries } from '$common/utils/url/url'
import { getUserInfo, isAndroid, goAppPath, getAppPath, removeUserInfo, goDownloadPage } from '$common/utils/common/common'
import storage from '$common/utils/storage';
import RuleDialog from '../../components/ruleDialog.vue'
import goPassPageMxins from '../../mixins/goPassPage'

export default {
  mixins: [goPassPageMxins],
  documentTitle: {
    i18n: "home.documentTitle"
  },
  data() {
    return {
      msg: '',
      ruleData: null,
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    isWownowApp: () => {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    mainStyle() {
      if (this.$root.clientHeight) {
        return `height: ${this.$root.clientHeight}px;`
      }
      return ''
    },
  },
  mounted() {
    const queries = urlQueries()
    this.activityNo = queries["activityNo"] || queries["i"]
    let data = storage.getItem(`taxiActivityCoupon_${this.activityNo}`);
    if (data) {
      data = JSON.parse(data)
      this.msg = data.msg
      this.ruleData = data.ruleData
    }
  },
  methods: {
  },
  components: {
    RuleDialog
  }
};

</script>

<style lang="stylus" scoped>
.mt-6 {
  margin-top: 6px;
}
.mr-4 {
  margin-right: 4px;
}

.mr-8{
  margin-right: 8px;
}

.flex-col{
  flex-direction: column;
}

.flex-icenter{
  display: flex;
  align-items: center;
}

.flex-xy-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.w-f{
  width: 100%;
}

.font-12{
  font-size: 12px;
}
.font-14{
  font-size: 14px;
}

.taxiAc-page{
  height: 100%;
  background-color: #BC2021;
  overflow-x: hidden;
  overflow-y: auto;

  .taxiAc-page-title{
    height: 25px;
    font-weight: 600;
    font-size: 18px;
    color: #fff;
  }

  .taxiAc-page-subtitle{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #fff;
    span{
      display: block;
      margin: 0 4px;
      transform: translateY(-3px);
    }
    strong {
      font-weight: bold;
      font-size: 32px;
    }
  }
}

.taxiAc-page-srl{
  margin: 0 auto;
  padding: 28px;
  width: 345px;
  background: #fff;
  border-radius: 32px;

  .taxiAc-srl-title{
    margin: 0 auto 23px auto;
    width: 266px;
    font-weight: 400;
    font-size: 16px;
  }

  .taxiAc-srl-coupon{
    width: 291px;
    height: 72px;
    background: url("https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/d444e08b3c2e4f21b52c762843fbbd7a.png") no-repeat;
    background-size: 100% 100%;
  }

  .taxiAc-srl-icon{
    margin-right: 8px;
    width: 44px;
    height: 44px;
  }
}

.taxiAc-srl-btn{
  margin: 30px auto 0 auto;
  padding: 18px 10px;
  width: 291px;
  height: 56px;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  background: #FC2040;
  border-radius: 32px;
  text-align: center;
  &:active{
    filter: brightness(0.9);
  }
}
</style>
